import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71500b8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71500b8a&prod&lang=scss&scoped=true"
import style1 from "../asset/css/index.scss?vue&type=style&index=1&id=71500b8a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71500b8a",
  null
  
)

export default component.exports